import { render, staticRenderFns } from "./CandleInfo.vue?vue&type=template&id=6ec319fb&scoped=true"
import script from "./CandleInfo.vue?vue&type=script&lang=js"
export * from "./CandleInfo.vue?vue&type=script&lang=js"
import style0 from "./CandleInfo.vue?vue&type=style&index=0&id=6ec319fb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec319fb",
  null
  
)

export default component.exports